import React from "react";
import { Typography, Grid } from "material-ui";
import TileIcon from "./TileIcon";
import PowerIcon from "material-ui-icons/PowerSettingsNew";

const IgnitionStatusTile = props => {
  const { lang, data } = props;
  const ignitionStatus = {
    Encendidas: data.EstatusUnidades.filter(d => d.Ignicion).length,
    Apagadas: data.EstatusUnidades.filter(d => !d.Ignicion).length
  };
  return (
    <div className="dashboard-tile">
      <TileIcon icon={PowerIcon} />
      <div className="tile-header">{lang.EstadoDeIgnicion}</div>
      <Grid container className="tile-body-divided">
        <Grid xl={6} lg={6} md={6} sm={6} xs={6} item className="subbody-1">
          <Typography color="textSecondary" align="center" variant="display3">
            {ignitionStatus.Encendidas}
          </Typography>
          <Typography
            variant="title"
            align="center"
            color="textSecondary"
            className="area"
            classes={{
              colorTextSecondary: "title-reportando"
            }}
          >
            {lang.Encendidas}
          </Typography>
        </Grid>
        <Grid xl={6} lg={6} md={6} sm={6} xs={6} item className="subbody-2">
          <Typography color="textSecondary" align="center" variant="display3">
            {ignitionStatus.Apagadas}
          </Typography>
          <Typography
            variant="title"
            align="center"
            color="textSecondary"
            className="area"
            classes={{
              colorTextSecondary: "title-fallando"
            }}
          >
            {lang.Apagadas}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default IgnitionStatusTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/IgnitionStatusTile.js